export const journeyCheckout = {
  header: {
    backButton: "Back",
    secureCheckout: "Fullscript secure checkout",
    patientInfo: "Patient info",
    payment: "Payment",
  },
  availability: {
    title: "First, let's confirm that Journeys is available in your area:",
    emailLabel: "Email address",
    zipCodeLabel: "Zip code",
    locationNote: "Availability based on location",
    continueButton: "Continue",
    uniqueTitle: "What makes Journeys unique?",
    features: {
      trackResults: "Track results over your lifetime",
      sharedProvider: "Shared between you and your provider",
      personalizedPlan: "Personalized health plan",
      noVisits: "No visits necessary",
    },
    errors: {
      packagePrefix: "Package:",
      zipCodePrefix: "Zip code:",
      notAvailable: "Journey is not available in your area",
      generalError: "An error occurred while checking availability. Please try again.",
    },
  },
  login: {
    welcomeBack: "Welcome back!",
    accountExists: "It looks like you already have a Fullscript account. Please login below",
    emailLabel: "Email address",
    passwordLabel: "Password",
    continueButton: "Continue",
    backButton: "Back",
    or: "Or",
    errors: {
      twoFactorNotSupported:
        "Two-factor authentication is not currently supported for Journey checkout. Please try a different sign-in method.",
      signInError: "An error occurred during sign-in. Please try again.",
    },
  },
  orderSummary: {
    title: "Order summary",
    journeyWith: "Journey with Dr. Alanis",
    productName: "Comprehensive Metabolic",
    interpretationTitle: "Interpretation & health plan",
    features: {
      labMarkers: "100 lab markers",
      chartAccess: "Permanent access to your chart",
      detailedInterpretation: "Detailed Interpretation of results",
      supplementList: "Supplement list",
      lifestyleRecommendations: "Lifestyle recommendations",
    },
    subtotal: "Subtotal",
    price: "$399.00",
    showOrderSummary: "Show order summary",
    hideOrderSummary: "Hide order summary",
  },
} as const;
